import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout'
import Home from './pages/Home';
import { WalletProvider } from './context/WalletContext';
import useReferral from './hooks/useReferral';


function App() {
  useReferral();
  return (
   
    <WalletProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </WalletProvider>
  );
}

export default App;
